export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["W trakcie"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ukończone"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oczekujące"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Następny"])}
}